import { areIntervalsOverlapping, parseISO } from 'date-fns';
import { IsoDate, IsoDateComplete, IsoDateCompleteRange, MultiDatesOverlapProps, SingleDatesOverlapProps } from './types';

const splitIsoDateCompleteRange = (range: IsoDateCompleteRange): [IsoDate, IsoDate] => {
	const { start, end } = range;
	const [criteriaRangeStart] = start.split('T');
	const [criteriaRangeEnd] = end.split('T');

	return [criteriaRangeStart as IsoDate, criteriaRangeEnd as IsoDate];
};

const doSingleDateRangesOverlap = ({ criteriaDateRange, searchDateRange }: SingleDatesOverlapProps) => {
	const [criteriaRangeStart, criteriaRangeEnd] = splitIsoDateCompleteRange(criteriaDateRange);
	const [searchRangeStart, searchRangeEnd] = searchDateRange.split('~');

	return areIntervalsOverlapping(
		{
			start: parseISO(searchRangeStart),
			end: parseISO(searchRangeEnd),
		},
		{
			start: parseISO(criteriaRangeStart),
			end: parseISO(criteriaRangeEnd),
		},
		{ inclusive: true },
	);
};

export const doMultiDateRangesOverlap = ({ criteriaDateRanges, searchDateRanges }: MultiDatesOverlapProps) => {
	if (!criteriaDateRanges || criteriaDateRanges?.length === 0) {
		return true;
	}

	for (const criteriaDateRange of criteriaDateRanges) {
		for (const searchDateRange of searchDateRanges) {
			const areDateRangesOverlapping = doSingleDateRangesOverlap({ criteriaDateRange, searchDateRange });

			if (areDateRangesOverlapping) {
				return true;
			}
		}
	}

	return false;
};

export const getDateRangesOverlap = ({ criteriaDateRanges, searchDateRanges }: MultiDatesOverlapProps) => {
	return criteriaDateRanges
		.map((criteriaDateRange) => {
			const filterDate = searchDateRanges.filter((searchDateRange) => {
				return doSingleDateRangesOverlap({ criteriaDateRange, searchDateRange });
			});

			if (!filterDate) {
				return criteriaDateRange;
			}

			const { start, end } = criteriaDateRange;
			const [outerRangeStart] = start.split('T');
			const [outerRangeEnd] = end.split('T');

			const mergeDates = filterDate.map((item) => {
				const [outerStart, outerEnd] = item.split('~');
				const startIsLower = parseISO(outerStart) >= parseISO(outerRangeStart);
				const startIsUpper = parseISO(outerEnd) <= parseISO(outerRangeEnd);
				const result: IsoDateCompleteRange = {
					start: (startIsLower ? parseISO(outerStart).toISOString() : start) as IsoDateComplete,
					end: (startIsUpper ? parseISO(outerEnd).toISOString() : end) as IsoDateComplete,
				};

				return result;
			});

			return mergeDates;
		})
		.flat();
};
